module.exports = __webpack_public_path__ + "static/img/irole.6958258.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/kr/irole.png
// module id = g8y+
// module chunks = 7